import { THEME_UI_DEFAULT_KEY as THEME_UI_DEFAULT_KEY$1 } from '@theme-ui/css';

var THEME_UI_DEFAULT_KEY = THEME_UI_DEFAULT_KEY$1;

export { THEME_UI_DEFAULT_KEY };
//# sourceMappingURL=types.esm.js.map
